import Vue from 'vue'
import Router from 'vue-router'
import Routers from './routerConfig'

Vue.use(Router)

export default new Router({
    routes:Routers,
    scrollBehavior(to, from, savedPosition) {
        // 如果是浏览器前进/后退，保留之前的滚动位置
        if (savedPosition) {
            return savedPosition
        } else {
            // 否则默认滚动到顶部
            return { x: 0, y: 0 }
        }
    }
})